import React from 'react';
import { useI18n } from '../utilities/i18n';
import { POSITION_LABELS, fieldDensityClass, generateFieldPositions } from '../utilities/lineupSetup';
import '../styles/onlineMatch.css';

export default function MatchFormationPreview({ teamName, teamLogo, formation, lineup, roster, color, fromCaptain }) {
  const { t } = useI18n();
  const head = (
    <div className="gm-formation-head">
      {teamLogo ? <img className="gm-formation-logo" src={teamLogo} alt="" /> : null}
      <span className="gm-formation-team">{teamName}</span>
      {formation ? <span className="gm-formation-scheme">{formation}</span> : null}
      {fromCaptain ? <span className="gm-cap-tag">{t('gmCaptainLineupPending')}</span> : null}
    </div>
  );
  if (!formation) {
    return (
      <div className="gm-formation">
        {head}
        <div className="gm-formation-empty">{t('gmNoFormation')}</div>
      </div>
    );
  }

  const positions = generateFieldPositions(formation);
  const findPlayer = (id) => (roster || []).find((player) => player.id === Number(id)) || null;
  const positionShort = (player, slotIndex) => {
    if (slotIndex === 0) return t('posGK');
    const position = player?.position_id || player?.match_position;
    return position ? (t(POSITION_LABELS[position] || '') || '') : '';
  };

  return (
    <div className="gm-formation">
      {head}
      <div className={`olm-field olm-field-lineup gm-field-preview ${fieldDensityClass(formation)}`}>
        <div className="olm-field-half-line" />
        <div className="olm-field-center-circle" />
        <div className="olm-field-penalty-area olm-field-penalty-bottom" />
        <div className="olm-field-penalty-area olm-field-penalty-top" />
        {positions.map((pos, index) => {
          const player = findPlayer(lineup?.[index]);
          return (
            <div
              key={index}
              className={`olm-field-slot ${player ? 'olm-field-slot-filled' : 'olm-field-slot-empty'}`}
              style={{
                top: `${pos.top}%`,
                left: `${pos.left}%`,
                background: player ? (index === 0 ? '#f39c12' : color) : 'transparent',
              }}
            >
              {player ? (
                <>
                  <span className="olm-field-player-pos">{positionShort(player, index)}</span>
                  <span className="olm-field-player-number">{player.match_number || player.player_number || ''}</span>
                  <span className="olm-field-player-name">{player.family}</span>
                </>
              ) : (
                <span className="olm-field-slot-label">{index === 0 ? 'GK' : index}</span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
